import { c as _c } from "react/compiler-runtime";
import { useAccountWallet } from "../../../global-account/react/index.js";
import { useAccount } from "wagmi";
import { CryptoPaymentMethodType } from "../components/common/CryptoPaymentMethod.js";
/**
 * Custom hook to determine which wallet to display and its address
 * Handles logic for showing EOA wallet, wagmi wallet, or global wallet based on payment method
 */
export function useConnectedWalletDisplay(selectedCryptoPaymentMethod) {
  const $ = _c(8);
  const {
    connectedEOAWallet,
    connectedSmartWallet
  } = useAccountWallet();
  const {
    address: wagmiAddress
  } = useAccount();
  let t0;
  if ($[0] !== connectedSmartWallet) {
    t0 = connectedSmartWallet?.getAccount()?.address;
    $[0] = connectedSmartWallet;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const globalWalletAddress = t0;
  let t1;
  if ($[2] !== connectedEOAWallet) {
    t1 = connectedEOAWallet?.getAccount()?.address;
    $[2] = connectedEOAWallet;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const connectedEOAAddress = t1;
  const shouldShowConnectedEOA = !!connectedEOAWallet;
  let walletAddress;
  if (selectedCryptoPaymentMethod === CryptoPaymentMethodType.GLOBAL_WALLET) {
    walletAddress = globalWalletAddress;
  } else {
    if (selectedCryptoPaymentMethod === CryptoPaymentMethodType.CONNECT_WALLET) {
      walletAddress = connectedEOAAddress || wagmiAddress;
    } else {
      walletAddress = connectedEOAAddress || wagmiAddress;
    }
  }
  let suggestedPaymentMethod = CryptoPaymentMethodType.NONE;
  if (connectedEOAAddress || wagmiAddress) {
    suggestedPaymentMethod = CryptoPaymentMethodType.CONNECT_WALLET;
  } else {
    if (globalWalletAddress) {
      suggestedPaymentMethod = CryptoPaymentMethodType.GLOBAL_WALLET;
    }
  }
  let t2;
  if ($[4] !== shouldShowConnectedEOA || $[5] !== suggestedPaymentMethod || $[6] !== walletAddress) {
    t2 = {
      walletAddress,
      shouldShowConnectedEOA,
      suggestedPaymentMethod
    };
    $[4] = shouldShowConnectedEOA;
    $[5] = suggestedPaymentMethod;
    $[6] = walletAddress;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}